import { Progress } from 'antd'
import React from 'react'

const DynamicProgress = (props) => {
    let { color, percent } = props
    return (
        <Progress type="dashboard" percent={percent} gapDegree={110} width={180} strokeColor={color} strokeWidth={5} format={(percent) => <span style={{ color: "black", fontWeight: "500" }}>{`${percent}%`}</span>} />
    )
}

export default DynamicProgress